module.exports = __webpack_public_path__ + "img/oab.28bee0b6.png";